import React from 'react'
import Button from 'react-bootstrap/Button'

import { isEmpty } from "../../../validation/index";
import AndroidPhone from './Sell-device/SamsungPhone.png'

import AirPods from './Sell-device/AirPods.jpg'
import GooglePhone from './Sell-device/GooglePhone.png'
import Ipad from './Sell-device/Ipad.png'
import Iphone from './Sell-device/Iphone.png'
import iwatch from './Sell-device/iwatch.jpg'
import Macbook from './Sell-device/Macbook .png'

const deviceList1 = [
  
  {
    devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/SellAdevicePage/iPhone_SellAdevice.jpg',
    buttonName: "iPhone",
    path: "/iPhone"
  },
  {
    devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/SellAdevicePage/macbook_SellADevice.jpg',
    buttonName: "MacBook",
    path: "/Macbook"
  },
  {
    devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/SellAdevicePage/iPad_SellAdevice.jpg',
    buttonName: "iPad",
    path: "/iPad"
  },

  {
    devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/SellAdevicePage/AirPods_SellADevice.jpg',
    buttonName: "AirPods",
    path: "/Airpods"
  }, 
  {
    devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/SellAdevicePage/iwatch_SellADevice.jpg',
    buttonName: "iWatch",
    path: "/iWatch"
  },
  {
    devicePhoto: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/SellAdevicePage/combine+xbox+sony+windows+(4).jpg',
    buttonName: "Other Devices",
    path: "/otherDevices"
  }
 
]




const SellBulk = (props) => {

  const goToPage = (path) => {
    props.history.push(path);
  }

  return (

    <div className='vh-70 '>
      <div>
        <div className=''>
          <br></br>
        <h6 className="text-center">Select your device</h6>
        <hr></hr>
        </div>
       

        <div className="grid-container">
          {
            !isEmpty(deviceList1) && deviceList1.map((item, index) => (
              <div className="grid-item" key={index} onClick={() => goToPage(item.path)}>
                <div className="bg-white">
                  <div className='justify-content-center'>
                  <img src={item.devicePhoto} className="cursor-pointer  w-50  h-auto "  />
                  </div>
                 
                </div>
                <div className=" mt-2 mb-2">
                  <Button className="w-100" onClick={() => goToPage(item.path)} variant="warning"><span style={{fontSize:13, fontFamily:''}}>{item.buttonName}</span></Button>
                </div>
              </div>
            ))
          }
        </div>


       



      </div >
    </div>
  )
}

export default SellBulk
